import React from 'react';
import UserMessage from './user-message';
import { useGSAP } from '@gsap/react';
import gsap from 'gsap';
import {
    MessageProps,
    RobotMessageAnimationHandle,
    UserMessageAnimationHandle,
} from './chat-demo-type-defs';
import RobotMessage from './robot-message';

// 一个消息的组件，包含用户消息和机器人消息
const Message: React.FC<MessageProps> = (props: MessageProps) => {
    const rootRef = React.useRef<HTMLDivElement>(null);
    const userMessageAnimationHandle =
        React.useRef<UserMessageAnimationHandle>(null);

    const robotMessageAnimationHandle =
        React.useRef<RobotMessageAnimationHandle>(null);

    useGSAP(
        () => {
            const tl = gsap.timeline({ repeat: -1, repeatDelay: 2 });
            tl.add(userMessageAnimationHandle.current!.getAnimation());
            tl.add(
                robotMessageAnimationHandle.current!.getAnimation(),
                '+=0.5',
            );
            tl.play();
        },
        { scope: rootRef },
    );

    return (
        <div
            ref={rootRef}
            className="tablet:pb-[24px] tablet:pt-[16px] flex h-full w-full flex-col gap-[4px] pb-[8px] pt-[8px]"
        >
            <UserMessage message={props} ref={userMessageAnimationHandle} />
            <RobotMessage message={props} ref={robotMessageAnimationHandle} />
        </div>
    );
};

export default React.memo(Message);
